import { render, staticRenderFns } from "./PimcoreModal.vue?vue&type=template&id=960250f6&scoped=true"
import script from "./PimcoreModal.vue?vue&type=script&lang=js"
export * from "./PimcoreModal.vue?vue&type=script&lang=js"
import style0 from "./PimcoreModal.vue?vue&type=style&index=0&id=960250f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960250f6",
  null
  
)

export default component.exports